<template>
  <div class="dropdown-wrapper">
    <span v-if="data.column.field === 'propertyName'">
      <v-select
        v-model="nativeAd.columnMappings.find(x => x.id === data.row.id).propertyId"
        :clearable="false"
        label="propertyName"
        append-to-body
        :calculate-position="withPopper"
        :placeholder="$tk('ClientPortal.Mappings.ChoosePropertyName')"
        :options="nativeAd.properties"
        :reduce="property => property.propertyId"
      />
    </span>
    <span v-else-if="data.column.field === 'catalogType'">
      <v-select
        v-model="nativeAd.columnMappings.find(x => x.id === data.row.id).catalogType"
        :clearable="false"
        label="name"
        append-to-body
        :calculate-position="withPopper"
        :placeholder="$tk('ClientPortal.Mappings.ChooseCatalogType')"
        :options="nativeAd.catalogMappingModels"
        :reduce="catalog => catalog.id"
        @option:selected="resetColumnName(nativeAd.columnMappings.find(x => x.id === data.row.id))"
      />
    </span>
    <span v-else>
      <div class="d-flex justify-content-between align-items-center">
        <div class="dropdown-wrapper--column-name">
          <v-select
            v-model="nativeAd.columnMappings.find(x => x.id === data.row.id).columnName"
            :clearable="false"
            append-to-body
            :calculate-position="withPopper"
            :placeholder="$tk('ClientPortal.Mappings.ChooseColumnName')"
            :options="nativeAd.catalogMappingModels.find(x => x.id === data.row.catalogType).columnNames"
          />
        </div>
        <b-button
          class="ml-1"
          size="sm"
          variant="link-secondary"
          @click="deleteMapping(data.index)"
        >
          <GjIcon
            name="Delete"
            class="text-danger"
          />
        </b-button>
      </div>
    </span>
  </div>
</template>

<script>
import {
  computed,
} from '@vue/composition-api'
import store from '@/store'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import vSelect from 'vue-select'
import { createPopper } from '@popperjs/core'

export default {
  components: {
    GjIcon,
    vSelect,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const nativeAd = computed(() => store.getters.getNativeAd)

    const deleteMapping = index => {
      nativeAd.value.columnMappings.splice(index, 1)
    }
    const resetColumnName = item => {
      item.columnName = ''
    }
    const withPopper = (dropdownList, component, { width }) => {
      document.body.style.overflowY = 'hidden'
      dropdownList.style.width = width
      dropdownList.style.zIndex = '9'
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 0],
            },
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top',
              )
            },
          },
        ],
      })
      return () => popper.destroy()
    }

    return {
      nativeAd,
      deleteMapping,
      resetColumnName,
      withPopper,
    }
  },
}
</script>
<style lang="scss">
  .dropdown-wrapper {
    position: relative;
    &--column-name{
      position: relative;
      width: 100%;
    }
  }
</style>
